import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { noLoaderContextValue } from '../commonservice/authentication.interceptor';
import { TaxType } from '../Models/billing';

@Injectable({
  providedIn: 'root'
})

export class BillingService {
  private headers: HttpHeaders;
  private urlencodedHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    this.urlencodedHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  }

  getData(path: string): Observable<any> {
    return this.http.get(path);
  }

  GetAllDisburesementbyJobId(JobId) {
    return this.http.get<any>('Billing/GetAllDisburesementbyJobId?JobId=' + JobId);
  }

  GetBillableInvoice(JobId) {
    return this.http.get<any>('Billing/GetBillableInvoice?JobId=' + JobId);
  }

  GetJobInvoiceList(JobId) {
    return this.http.get<any>('Billing/GetJobInvoiceList?JobId=' + JobId);
  }

  GetJobInvoiceHistory(InvoiceId) {
    return this.http.get<any>('Billing/GetJobInvoiceHistory?InvoiceId=' + InvoiceId);
  }

  GetUserTimesheetbyJobId(JobId) {
    return this.http.get<any>('Billing/GetUserTimesheetbyJobId?JobId=' + JobId);
  }

  getUserTimesheetAndDisbursementbyJobId(JobId) {
    return this.http.get<any>(`Billing/GetWIPTransactionsbyJobId?JobId=${JobId}`);
  }

  GetUsersforTimelogbyJobId(JobId) {
    return this.http.get<any>('Billing/GetUsersforTimelogbyJobId?JobId=' + JobId);
  }

  GetUsersTimelogbyJobIdForGroupBy(JobId) {
    return this.http.get<any>('Billing/GetUsersTimelogbyJobIdForGroupBy?JobId=' + JobId);
  }

  GetUsersTimelogbyJobIdForGroupByTask(JobId) {
    return this.http.get<any>('Billing/GetUsersTimelogbyJobIdForGroupByTask?JobId=' + JobId);
  }

  GetJobPaymentsInvoice(JobId) {
    return this.http.get<any>('Billing/GetJobPaymentsInvoice?JobId=' + JobId);
  }

  GetInvoiceDetail(JobId, InvoiceId, wipUntilDate: string | null) {
    return this.http.get<any>('Billing/GetInvoiceDetail?JobId=' + JobId + '&InvoiceId=' + InvoiceId + '&wipUntilDate=' + wipUntilDate);
  }

  GetInterimvalue(JobId) {
    return this.http.get<any>('Billing/GetInterimvalue?JobId=' + JobId);
  }

  GetInvoiceList() {
    return this.http.get<any>('Billing/GetInvoiceList');
  }

  GetClientListForFilter() {
    return this.http.get<any>('Billing/GetClientListForFilter');
  }

  GetFinancialYear() {
    return this.http.get<any>('Billing/GetAllFinancialYearDetails');
  }

  GetJobs() {
    return this.http.get<any>('Billing/GetJoblistFirmInvoice');
  }

  ApproveAll(InvoiceIds) {
    return this.http.get<any>('Billing/ApproveAllInvoices?InvoiceIds=' + InvoiceIds);
  }

  ArchiveAll(InvoiceIds) {
    return this.http.get<any>('Billing/ArchiveAllInvoices?InvoiceIds=' + InvoiceIds);
  }

  GetJobStatusList() {
    return this.http.get<any>('Billing/GetJobStatusList');
  }

  GetFilteredWip(wipmodel) {
    return this.http.post<any>('Billing/GetFilteredWip', wipmodel, { headers: this.headers });
  }

  GetWipInvoiceDetail(JobIds) {
    return this.http.get<any>('Billing/GetWipInvoiceDetail?JobIds=' + JobIds);
  }

  GetJobWIPInvoiceClientDetail(JobIds) {
    return this.http.get<any>('Billing/GetJobWIPInvoiceClientDetail?JobIds=' + JobIds);
  }

  GetJobWIPInvoicesummary(JobId: string, wipUntilDate?: string | null, invoiceId?: number | null, wIPUntilChange = false) {
    let params = new HttpParams()
      .set('JobId', JobId)
      .set('invoiceId', invoiceId?.toString() || '')
      .set('wIPUntilChange', wIPUntilChange); // Dev Rahul Newara CUST-9829 Date: 25-02-2025
    if (wipUntilDate) {
      params = params.set('wipUntilDate', wipUntilDate);
    }
    return this.http.get<any>('Billing/GetJobBillableInvoice', { params });
  }

  GetPaymentListDetails(invoiceId) {
    return this.http.get<any>('Billing/GetPaymentListDetails?invoiceId=' + invoiceId);
  }

  GetViewInvoiceDetails(invoiceNumber) {
    return this.http.get<any>('Billing/GetViewInvoiceDetails?invoiceNumber=' + invoiceNumber);
  }

  GetBulkJobForInvoice(JobIds) {
    return this.http.get<any>('Billing/GetBulkJobForInvoice?JobIds=' + JobIds);
  }

  GetInvoiceSummaryForJob(JobId) {
    return this.http.get<any>('Billing/GetInvoiceSummaryForJob?JobId=' + JobId);
  }

  GetClientInvoiceHistory(InvoiceNo) {
    return this.http.get<any>('Billing/GetClientInvoiceHistory?InvoiceNo=' + InvoiceNo);
  }

  GetDisbursementAndPayments(JobIds, ClientId) {
    return this.http.get<any>('Billing/GetDisbursementAndPayments?JobIds=' + JobIds + '&ClientId=' + ClientId);
  }

  GetAllBillingflowView() {
    return this.http.get<any>('Billing/GetAllBillingflowView');
  }

  GetAllBillingWipView() {
    return this.http.get<any>('Billing/GetAllBillingWipView');
  }

  GetJobBillableInvoice(JobId: string, wipUntilDate: string | null, invoiceId: number) {
    let params = new HttpParams()
      .set('JobId', JobId).set('invoiceId', invoiceId);
    if (wipUntilDate) params = params.set('wipUntilDate', wipUntilDate);
    return this.http.get<any>('Billing/GetJobBillableInvoice', { params, headers: this.headers });
  }

  CheckIsDebtorclient(_cid) {
    return this.http.get<any>('Billing/CheckIsDebtorclient?ClientId=' + Number(_cid) + '', { headers: this.headers })
  }

  GetJobDetailInvoiceTemplate(JobId, CategoryId) {
    return this.http.get<any>('Billing/GetJobDetailInvoiceTemplate?JobId=' + JobId + '&CategoryId=' + CategoryId);
  }

  GetInvoiceTemplate() {
    return this.http.get<any>('Billing/GetInvoiceTemplate');
  }

  PreviewInvoice(invoiceDetails, templateId) {
    return this.http.post(`Billing/PreviewInvoice/${templateId}`, invoiceDetails, { observe: 'response', responseType: 'blob' as 'json' })
  }

  GetInvoiceDetailForClient(InvoiceId) {
    return this.http.get<any>('Billing/GetInvoiceDetailForClient?InvoiceId=' + InvoiceId);
  }

  DownloadPdfFile(param) {
    return this.http.post<any>('Billing/DownloadPdfFile', param, { headers: this.headers });
  }

  SetInvoiceIsSent(InvoiceId, IsSent) {
    return this.http.get<any>('Billing/SetInvoiceIsSent?InvoiceId=' + InvoiceId + '&IsSent=' + IsSent, { headers: this.headers });
  }

  AddCreditAdjustment(data: any) {
    return this.http.post<any>('Billing/AddCreditAdjustment', data, { headers: this.headers });
  }

  AddDebitAdjustment(data: any) {
    return this.http.post<any>('Billing/AddDebitAdjustment', data, { headers: this.headers });
  }
  UpdateCreditAdjustment(data: any) {
    return this.http.post<any>('Billing/UpdateCreditAdjustment', data, { headers: this.headers });
  }

  UpdateDebitAdjustment(data: any) {
    return this.http.post<any>('Billing/UpdateDebitAdjustment', data, { headers: this.headers });
  }

  CancelAdjustment(AdjustmentId) {
    return this.http.post<any>('Billing/CancelAdjustment?adjustmentId=' + AdjustmentId, { headers: this.headers });
  }

  UpdateInvoiceApprovalStatus(InvoiceId: number, approvalStatus: string, invoiceDate: string | null, invoiceDueDate: string | null, templateId: number, wipUntilDate: string | null, assignedUserId: string | null, rejectionComments: string | null) {
    const params = new HttpParams()
      .set('InvoiceId', InvoiceId)
      .set('approvalType', approvalStatus)
      .set('invoiceDate', invoiceDate || '')
      .set('invoiceDueDate', invoiceDueDate || '')
      .set('templateId', templateId)
      .set('wipUntilDate', wipUntilDate)
      .set('assignedUserId', assignedUserId || '')
      .set('rejectionComments', rejectionComments || '');
    return this.http.get<any>('Billing/UpdateInvoiceApprovalStatus', {
      headers: this.headers,
      params: params
    });
  }

  GetFirmGSTDetail() {
    return this.http.get<any>('Billing/GetFirmGSTDetail');
  }

  GetTotalBillableAmountForJob(JobId) {
    return this.http.get<any>('Billing/GetTotalBillableAmountForJob?JobId=' + JobId);
  }

  AddInvoicedJobDetail(invoicedData) {
    return this.http.post<any>('Billing/AddInvoicedJobDetail', invoicedData);
  }

  GetAllInvoicesOfClient(ClientId) {
    return this.http.get<any>('Billing/GetAllInvoicesOfClient?ClientId=' + ClientId, { headers: this.headers });
  }

  GetAllDebtsOfClient(ClientId, flag) {
    if (flag) {
      return this.http.get<any>('Billing/GetDebtListByClientId?ClientId=' + ClientId + '&flag=' + flag, { headers: this.headers });
    } else {
      return this.http.get<any>('Billing/GetDebtListByClientId?ClientId=' + ClientId, { headers: this.headers });
    }
  }

  DeleteInvoiceDocForDMS(cancelInvoiceDetails) {
    return this.http.post<any>('Billing/DeleteInvoiceDoc', cancelInvoiceDetails, { headers: this.headers });
  }

  CheckFinalExistForBulkInvoice(JobIds) {
    return this.http.get<any>('Billing/CheckFinalExistForBulkInvoice?JobIds=' + JobIds);
  }

  GetJobInvoiceActivity(InvoiceId) {
    return this.http.get<any>('Billing/GetJobInvoiceActivity?InvoiceId=' + InvoiceId, { headers: this.headers });
  }

  AddJobInvoiceActivity(activityData: string) {
    return this.http.post('Billing/AddJobInvoiceActivity', { activityData: activityData }, { headers: this.headers });
  }

  GetUserInvoiceDetails(JobId: string, wipUntilDate: string | null) {
    let params = new HttpParams()
      .set('JobId', JobId)
    if (wipUntilDate) params = params.set('wipUntilDate', wipUntilDate);
    return this.http.get<any>('Billing/GetUserInvoiceDetails', { params, headers: this.headers });
  }

  GetTaskDetailsforInvoice(JobId: number, UserId, wipUntilDate: string | null) {
    let params = new HttpParams()
      .set('JobId', JobId)
      .set('UserId', UserId)
    if (wipUntilDate) params = params.set('wipUntilDate', wipUntilDate);
    return this.http.get<any>('Billing/GetTaskDetailsforInvoice', { params, headers: this.headers });
  }

  IsApprovalEnable() {
    return this.http.get<any>('Billing/IsApprovalEnable');
  }

  DeleteInvoiceDetail(InvoiceNumber) {
    return this.http.post('Billing/DeleteInvoiceDetail?InvoiceNumber=' + InvoiceNumber, { headers: this.headers });
  }

  GetInvoiceSummaryDetail(InvoiceNumber, jobId) {
    return this.http.get<any>('Billing/GetInvoiceSummaryDetail?InvoiceNumber=' + InvoiceNumber + '&jobId=' + jobId, { headers: this.headers });
  }

  UpdateUnapprovedWIP(intLogTimeId: number) { // Revert the changes because it not working with change
    return this.http.post('Billing/UpdateUnapprovedWIP?intLogTimeId=' + intLogTimeId, { headers: this.headers });
  }

  GetJobWip(JobId, wipUntilDate) {
    let params = new HttpParams()
      .set('jobId', JobId)
    if (wipUntilDate) params = params.set('wipUntilDate', wipUntilDate);
    return this.http.get<any>('Billing/GetJobWip', { params, headers: this.headers });
  }

  GetDraftTimeSheet(jobIds) {
    return this.http.get<any>('Billing/GetDraftTimeSheet?jobIds=' + jobIds, { headers: this.headers });
  }

  GetInvoiceNarration(jobIds) {
    return this.http.get<any>('Billing/GetInvoiceNarration?jobIds=' + jobIds, { headers: this.headers });
  }

  checkStandardInvoiceforJob(JobId) {
    return this.http.get<any>('Billing/checkStandardInvoiceforJob?JobId=' + JobId, { headers: this.headers });
  }

  GetInvoiceDetailForEdit(InvoiceId) {
    return this.http.get<any>('Billing/GetInvoiceDetailForEdit?invoiceId=' + InvoiceId);
  }

  GetInvoiceBillableType(InvoiceId) {
    return this.http.get<any>('Billing/GetInvoiceBillableType?invoiceId=' + InvoiceId);
  }

  GetInvoicedTimeLog(jobId, InvoiceId, invoiceNumber) {
    return this.http.get<any>('Billing/GetInvoicedTimeLog?jobId=' + jobId + '&invoiceId=' + InvoiceId + '&invoiceNumber=' + invoiceNumber);
  }

  GetInvoicedUserId(jobId, InvoiceId, invoiceNumber) {
    return this.http.get<any>('Billing/GetInvoicedUserId?jobId=' + jobId + '&invoiceId=' + InvoiceId + '&invoiceNumber=' + invoiceNumber);
  }

  GetInvoicedDisbursementId(jobId, InvoiceId, invoiceNumber) {
    return this.http.get<any>('Billing/GetInvoicedDisbursementId?jobId=' + jobId + '&invoiceId=' + InvoiceId + '&invoiceNumber=' + invoiceNumber);
  }

  getInvoiceStatementPdf(clientId, fromDate, toDate, billingEntityIds): Observable<Blob> {
    return this.http.post('Billing/GetInvoiceStatement?clientId=' + clientId + '&fromDate=' + fromDate + '&toDate=' + toDate, billingEntityIds, {
      responseType: 'blob'
    });
  }

  getJobsDetailsForRecurringInvoice(jobIds) {
    let params = new HttpParams({ fromObject: { 'jobIds': jobIds } });
    return this.http.get<any>('Billing/GetJobsDetailsForRecurringInvoice', {
      params: params
    });
  }

  getJobAllNarrations(jobIds) {
    let params = new HttpParams({ fromObject: { 'jobIds': jobIds } });
    return this.http.get<any>('Billing/GetJobAllNarrations', {
      params: params
    });
  }

  SaveRecurringInvoice(data) {
    return this.http.post<any>('Billing/AddEditRecurringInvoice', data, { headers: this.headers });
  }

  GetRecurringInvoice() {
    return this.http.get<any>('Billing/GetRecurringInvoice');
  }

  getRecurringDetailsById(recurringId: number) {
    return this.http.get<any>('Billing/GetRecurringInvoiceById?RecurringId=' + recurringId);
  }

  deleteRecurringInvoiceById(recurringId: number) {
    return this.http.post<any>('Billing/DeleteRecurringInvoiceById?recurringId=' + recurringId, { headers: this.headers });
  }

  getInvoiceViewAllocationDetails(InvoiceId, jobId) {
    return this.http.get<any>('Billing/GetInvoiceDetails?InvoiceId=' + InvoiceId + '&jobId=' + jobId);
  }

  GetProBonoUser() {
    return this.http.get<any>('UserManagement/GetProBonoUserForFirm', { headers: this.headers });
  }

  GetInterimToAllocation(jobId) {
    return this.http.get<any>('Billing/GetInterimToAllocation?jobId=' + jobId);
  }

  GetTimesheetByLogTimeId(logTimeId) {
    return this.http.get<any>('Billing/GetTimesheetByLogTimeId?logTimeId=' + logTimeId);
  }

  AddWIPTransfer(wIPTranferData) {
    let wIPTransfer = {
      WIPTransferData: wIPTranferData
    };
    return this.http.post<any>('Billing/AddWIPTransfer', wIPTransfer, { headers: this.headers });
  }

  GetClientListByBillingEntityid(billingEntityid) {
    return this.http.get<any>('Billing/GetClientListByBillingEntityid?billingEntityid=' + billingEntityid);
  }

  AddEditGridView(gridViewData) {
    return this.http.post<any>('Billing/AddEditGridView', gridViewData, { headers: this.headers });
  }

  GetGridView(GridType) {
    return this.http.get<any>('Billing/GetGridView?gridType=' + GridType, { headers: this.headers });
  }

  GetRolePrivilegesAmount() {
    return this.http.get<any>('UserManagement/GetRolePrivilegesAmount');
  }

  GetInterimAllocationUsedAmount(jobId, invoiceId) {
    return this.http.get<any>('Billing/GetInterimAllocationUsedAmount?jobId=' + jobId + "&invoiceId=" + invoiceId);
  }

  GetJobQuoteByJobId(jobId, editModeFlag) {
    return this.http.get<any>('Billing/GetJobQuoteByJobId?jobId=' + Number(jobId) + '&editModeFlag=' + editModeFlag + '', { headers: this.headers });
  }

  AddEditQuoteDetail(quoteData) {
    return this.http.post<any>('Billing/AddEditQuoteDetail', quoteData, { headers: this.urlencodedHeaders });
  }

  getInvoiceListForClient(clientId: number, flag: string) {
    return this.http.get<any>(`Billing/GetInvoiceListForClient?ClientId=${clientId}&Flag=${flag}`);
  }

  CheckunApprovedOrFinalInvoice(jobId) {
    return this.http.get<any>('Billing/CheckunApprovedOrFinalInvoice?jobId=' + jobId);
  }

  GetInvoiceDetailsForCreditNote(invoiceId) {
    return this.http.get<any>('Billing/GetInvoiceDetailsForCreditNote?invoiceId=' + invoiceId);
  }

  AddCreditNoteToInvoice(data) {
    return this.http.post<any>('Billing/AddCreditNoteToInvoice', data, { headers: this.headers });
  }

  GetCreditDetailsById(cId) {
    return this.http.get<any>('Billing/GetCreditDetailsById?creditId=' + +cId, { headers: this.headers });
  }

  AddCreditNoteComment(data) {
    return this.http.post<any>(`Billing/AddCreditNoteComment?creditNoteId=${data.creditNoteId}&comment=${data.comment}`, { headers: this.headers });
  }

  UpdateCreditNoteStatus(data) {
    return this.http.post<any>(`Billing/UpdateCreditNoteStatus?creditNoteId=${data.creditNoteId}&status=${data.status}`, data, { headers: this.headers });
  }

  updateInvoiceStatus(extraParameters, params) {
    if (extraParameters) {
      const creditNotePath = params.createCreditNote !== undefined && params.createCreditNote !== null
        ? `/${params.createCreditNote}`
        : '/false';

      return this.http.post(
        `Billing/UpdateInvoiceStatus/${params.InvoiceId}/${params.toStatusId}/${params.type}/${params.invoiceNo}/${params.clientId}/${params.invoiceDateStr}/${params.dueDateStr}/${params.templateId}/${params.wipUntilDate}${creditNotePath}`,
        { headers: this.urlencodedHeaders }
      );
    }
    else {
      return this.http.post<any>(`Billing/UpdateInvoiceStatus/${params.InvoiceId}/${params.toStatusId}/${params.type}/${params.invoiceNo}/${params.clientId}`, { headers: this.headers });
    }
  }

  addInvoiceComment(comment) {
    return this.http.post<any>('Billing/AddEditInvoiceComment', comment, { headers: this.headers })
  }

  generateInoiceDocument(invoiceId, templateId) {
    return this.http.post<any>(`Billing/GenerateInvoiceDocument?invoiceId=${invoiceId}&templateId=${templateId}`, { headers: this.headers });
  }

  CheckRecurringInvoiceJobs(jobIds, invoiceDate) {
    return this.http.get<any>('Billing/CheckRecurringInvoiceJobs?jobIds=' + jobIds + "&invoiceDate=" + invoiceDate);
  }

  GetInvoiceEmailBody() {
    return this.http.get<any>('Billing/GetInvoiceEmailBody', { headers: this.headers });
  }

  async getAddEditSharedView(sharedViewDetails): Promise<any> {
    return await this.http.post<any>('Billing/AddEditSharedView', sharedViewDetails, { headers: this.headers }).toPromise();
  }

  getAllViewsByUserId(GridType): Observable<any> {
    return this.http.get<any>('Billing/GetAllViewsByUserId?gridType=' + GridType, { headers: this.headers });
  }

  getWipData(state): Promise<any> {
    return this.http.post<any>('BillingGrid/LoadData', state, { headers: this.headers }).toPromise();
  }
  getWipWithDataFilter(state): Promise<any> {
    return this.http.post<any>('BillingGrid/LoadData_V1', state, { headers: this.headers }).toPromise();
  }

  getUpdateNarration(updateNarrationModel) {
    return this.http.post('Billing/UpdateNarration', updateNarrationModel, { headers: this.headers })
  }

  getJobDetail(_TempJobId) {
    return this.http.get<any>('Billing/GetJobDetail?JobId=' + _TempJobId, { headers: this.headers });
  }

  DeleteJobInvoice(invoiceId, type) {
    return this.http.get<any>('Billing/DeleteJobInvoice?InvoiceId=' + invoiceId + '&type=' + type)
  }

  MarkAsArchiveInvoice(invoiceId, type) {
    return this.http.get<any>('Billing/MarkAsArchiveInvoice?InvoiceId=' + invoiceId + '&type=' + type);
  }

  AddEditWriteoffonReasons(payload) {
    return this.http.post<any>('Billing/AddEditWriteoffonReasons', payload);
  }

  sortWriteoffonReasons(payload,IsUnAllocated: boolean) {
    return this.http.post<any>('Billing/SortWriteoffonReasons?IsUnAllocated=' + IsUnAllocated, payload);
  }

  deleteWriteoffonReasons(id: number, IsUnAllocated: boolean) {
    return this.http.get('Billing/DeleteWriteoffonReason?id=' + id + '&IsUnAllocated=' + IsUnAllocated);
  }

  getWriteoffOnReasons(IsUnAllocated: boolean) {
    return this.http.get('Billing/GetWriteoffonReasons?IsUnAllocated=' + IsUnAllocated);
  }

  addEditDeposit(Deposit) {
    return this.http.post<any>('Billing/AddEditDeposit', Deposit)
  }

  GetDepositDetail(JobId, isEditMode) {
    return this.http.get<any>('Billing/GetDepositById?JobId=' + JobId + '&isEditMode=' + isEditMode);
  }

  getBillingEntitiesForTemplate(): Observable<any> {
    const url = `BillingEntity/GetAllBillingEntitiesforselect`;
    return this.http.get<any>(url, { headers: this.headers });
  }

  getBillingEntities(IsArchived) {
    return this.http.get<any>('BillingEntity/GetBillingEntity/' + IsArchived);
  }

  postBillingEntity(formData) {
    return this.http.post<any>('BillingEntity/AddEditBillingEntity', formData);
  }

  postBillingEntityStatus(id, isStatus) {
    let data = {
      BillingEntityId: id,
      isStatus: isStatus
    }
    return this.http.post<any>('BillingEntity/SetBillingEntityDataStatus', data, { headers: this.headers });
  }

  archiveBillingEntity(id: string) {
    let data = { BillingEntityId: id }
    return this.http.post<any>('BillingEntity/ArchiveBillingEntityData', data, { headers: this.headers });
  }

  GetDebtorClientName(clientId, invoiceId = null) {
    return this.http.get<any>('Billing/GetDebtorClientName?clientId=' + clientId + '&invoiceId=' + invoiceId)
  }

  GetDebtorClientJobDetails(debtorClientList) {
    return this.http.get<any>('Billing/GetDebtorClientJobDetails?clientId=' + debtorClientList, { headers: this.urlencodedHeaders })
  }

  AddClientBulkInvoice(invoiceModel1) {
    return this.http.post<any>('Billing/AddClientBulkInvoice', invoiceModel1)
  }

  getJobBillingList(cid: number, flag: string) {
    return this.http.get<any>(`Billing/GetJobBillingList?cid=${cid}&Flag=${flag}`);
  }

  matchAndMoveWipTransactions(payload: any) {
    return this.http.post<any>(`Billing/MatchAndMoveWIPs?clientId=${payload.clientId}&jobId=${payload.jobId}`, { comments: payload.comments ?? '', wipToTransfer: payload.wipToTransfer });
  }

  notMatchedTaskMoveTransactions(payload: any) {
    return this.http.post<any>(`Billing/MoveWIPTransactions?clientId=${payload.clientId}&jobId=${payload.jobId}`, payload.wipToTransfer);
  }

  unMatchedTaskMoveTransactions(payload: any) {
    return this.http.post<any>(`Billing/MoveWIPTransactions?clientId=${payload.clientId}&jobId=${payload.jobId}`, { comments: payload.comments ?? '', wipToTransfer: payload.wipToTransfer });
  }

  getInvoiceListWIP() {
    return this.http.get<any>('Billing/GetInvoiceListWIP');
  }

  updatePreparerReviewerApprover(payload: any) {
    return this.http.post(`Billing/AssignInvoiceRoles`, payload, { headers: this.headers })
  }

  downloadCreditNote(creditNoteId): Observable<HttpResponse<Blob>> {
    return this.http.get('Billing/DownloadCreditNotePDF?creditNoteId=' + creditNoteId, { responseType: 'blob', observe: 'response' });
  }

  downloadFeeReversalNote(invoiceId): Observable<HttpResponse<Blob>> {
    return this.http.get('Billing/DownloadFeeReversalNotePDF?invoiceId=' + invoiceId, { responseType: 'blob', observe: 'response' });
  }

  isBulkSendInvoiceEnable() {
    return this.http.post<any>('Billing/IsBulkSendInvoiceEnable', { headers: this.headers });
  }

  getBulkSendInvoiceEmailList(body: any, emailType: string, connectionType: string = 'MSO365') {
    const params = new HttpParams()
      .set('emailType', emailType)
      .set('connectionType', connectionType);
    return this.http.post<any>('Billing/GetBulkSendInvoiceEmailList', body, { params });
  }

  addBulkInvoiceEmail(payload) {
    return this.http.post<any>('Billing/AddBulkSendInvoiceDetails', payload, { headers: this.headers });
  }

  getBillingEntitiesbyClient(clientId, isArchived) {
    return this.http.get<any>('BillingEntity/GetAllBillingEntitiesbyClientId?clientId=' + clientId + '&IsArchived=' + isArchived);
  }

  getWIPDetailsByJob(jobId, logTimeIds: number[], wipUntilDate: string | null, isInvoicePageMode: string | null, disbursementIds: number[] | null = null) {
    const jobParams: any = {
      JobId: jobId,
      LogTimeIds: logTimeIds,
      WipUntilDate: (wipUntilDate && wipUntilDate.trim() !== '') ? wipUntilDate : null,
      IsViewMode: isInvoicePageMode === 'view' ? true : false
    };
    // Only restrict disbursements when an explicit list is supplied (draft edit / actual invoice flows)
    if (Array.isArray(disbursementIds)) {
      jobParams.DisbursementIds = disbursementIds;
    }
    return this.http.post<any>('Billing/GetWIPDetailsByJob', jobParams);
  }

  getWIPSummaryByJobs(jobIds: number[], wipUntilDate: string | null) {
    if (wipUntilDate != null && wipUntilDate.toString().trim() !== '') {
      return this.http.post<any>(`Billing/GetWIPSummaryByJobs?wipUntilDate=${wipUntilDate}`, jobIds);
    } else {
      return this.http.post<any>(`Billing/GetWIPSummaryByJobs`, jobIds);
    }
  }

  // WIP summary restricted to the given time / disbursement ids (null list = no restriction)
  getWIPSummaryByJobsAndIds(jobIds: number[], wipUntilDate: string | null, logTimeIds: number[] | null, disbursementIds: number[] | null) {
    const wipSummaryRequest = {
      JobIds: jobIds,
      LogTimeIds: logTimeIds,
      DisbursementIds: disbursementIds,
      WipUntilDate: (wipUntilDate != null && wipUntilDate.toString().trim() !== '') ? wipUntilDate : null
    };
    return this.http.post<any>(`Billing/GetWIPSummaryByJobsAndIds`, wipSummaryRequest);
  }

  GetUnapprovedTimeEntriesByJobs(jobIds: number[]) {
    return this.http.post<any>(`Billing/GetUnapprovedTimeEntriesByJobs`, jobIds);
  }

  GetInterimInvoicesByJob(jobIds: number[]) {
    return this.http.post<any>(`Billing/GetInterimsByJobs`, jobIds);
  }

  getNewlyAddedTimesByJobs(timeLogRequest) {
    return this.http.post<any>(`Billing/GetNewlyAddedTimeLogs`, timeLogRequest);
  }

  getNewlyAddedDisbursementsByJobs(disbursementRequest) {
    return this.http.post<any>(`Billing/GetNewlyAddedDisbursements`, disbursementRequest);
  }

  getAssignInvoiceRoles(assignInvoiceRolesRequest) {
    return this.http.post<any>(`billing/AssignInvoiceRoles`, assignInvoiceRolesRequest);
  }

  GetTimeSheetDetailsByLogTimeIds(logTimeIds: number[], wipUntilDate: string | null) {
    if (wipUntilDate != null && wipUntilDate.toString().trim() !== '') {
      return this.http.post<any>(`Billing/GetTimeSheetDetailsByLogTimeIds?wipUntilDate=${wipUntilDate}`, logTimeIds);
    }
    else {
      return this.http.post<any>(`Billing/GetTimeSheetDetailsByLogTimeIds`, logTimeIds);
    }
  }

  GetInvoiceDetailsByInvoiceId(InvoiceId: number) {
    return this.http.get<any>('Billing/GetInvoiceDetailsByInvoiceId?InvoiceId=' + InvoiceId);
  }

  AddBadDebt(data: any) {
    return this.http.post<any>(
      `API/BadDebt/Create`,
      data,
      { headers: this.headers }
    );
  }

  GetBadDebtById(badDebtId: number) {
    return this.http.get<any>(
      `API/BadDebt/GetBadDebtById/${badDebtId}`,
      { headers: this.headers }
    );
  }

  UpdateBadDebt(data: any) {
    return this.http.post<any>(
      `API/BadDebt/Update`,
      data,
      { headers: this.headers }
    );
  }

  GetBadDebtByInvoiceId(InvoiceId: number) {
    return this.http.get<any>(
      `API/BadDebt/GetBadDebtByInvoiceId/${InvoiceId}`,
      { headers: this.headers }
    );
  }

  getAllTaxTypes(): Observable<TaxType[]> {
    return this.http.get<TaxType[]>('Billing/GetAllTaxTypes');
  }

  UpdateWIPLockInfo(WIPLockRequest) {
    return this.http.post<any>(`Billing/UpdateWIPLockDetails`, WIPLockRequest, { headers: this.headers });
  }

  getWIPLockInfo(WIPLockRequest) {
    return this.http.post<any>(`Billing/GetWIPLockDetails`, WIPLockRequest, { headers: this.headers });
  }

  getReleaseWIPLockedList(selectedTime) {
    return this.http.get<any>('Billing/GetReleaseWIPLockedDetails', { params: { timeInterval: selectedTime } });
  }

  getJobsWipDetails(jobIds: number[], wipUntilDate: string | null) {
    return this.http.post<any>(`Billing/GetJobsWIPDetails?wipUntilDate=${wipUntilDate}`, jobIds);
  }
  getWipGroupCounts(requestData: any): Observable<any> {
    return this.http.post<any>('BillingGrid/GetWipGroupCounts', { value: requestData }, { context: noLoaderContextValue });
  }
}
